import { render, staticRenderFns } from "./customKanBan.vue?vue&type=template&id=1f531d30&scoped=true&"
import script from "./customKanBan.vue?vue&type=script&lang=js&"
export * from "./customKanBan.vue?vue&type=script&lang=js&"
import style0 from "./customKanBan.vue?vue&type=style&index=0&id=1f531d30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f531d30",
  null
  
)

export default component.exports